import { PhysicalExaminationData } from './types';

export const createEmptyPhysicalExamination = (): PhysicalExaminationData => ({
  vitalSigns: {
    bloodPressureSystolic: '',
    bloodPressureDiastolic: '',
    heartRate: '',
    respiratoryRate: '',
    temperature: '',
    oxygenSaturation: '',
  },
  headNeck: {
    normal: false,
    cranium: '',
    eyes: '',
    ent: '',
    neck: '',
  },
  thorax: {
    normal: false,
    respiratory: '',
    cardiovascular: '',
  },
  abdomen: {
    normal: false,
    inspection: '',
    auscultation: '',
    palpation: '',
    percussion: '',
  },
  extremities: {
    normal: false,
    inspection: '',
    edema: '',
    skinHair: '',
    pulses: '',
  },
  neurological: {
    normal: false,
    alertnessOrientation: '',
    speech: '',
    cranialNerves: '',
    muscleStrength: '',
    sensation: '',
    gaitBalance: '',
    cerebellarSigns: '',
  },
});

// Helper to check if a section has any content (excludes `normal` field)
export const sectionHasContent = (
  section: Record<string, string | boolean | undefined>
): boolean => {
  return Object.entries(section).some(
    ([key, value]) =>
      key !== 'normal' && typeof value === 'string' && value.trim() !== ''
  );
};

// Helper to check if examination has any data
export const hasExaminationData = (
  data: PhysicalExaminationData | null
): boolean => {
  if (!data) {
    return false;
  }

  const empty = createEmptyPhysicalExamination();

  // Check vital signs
  const hasVitalSigns = Object.entries(data.vitalSigns).some(
    ([key, value]) =>
      value !== empty.vitalSigns[key as keyof typeof empty.vitalSigns]
  );
  if (hasVitalSigns) {
    return true;
  }

  // Check each section
  const sections: (keyof PhysicalExaminationData)[] = [
    'headNeck',
    'thorax',
    'abdomen',
    'extremities',
    'neurological',
  ];

  for (const section of sections) {
    const sectionData = data[section] as Record<string, string>;
    const emptySection = empty[section] as Record<string, string>;
    const hasData = Object.entries(sectionData).some(
      ([key, value]) => value !== emptySection[key]
    );
    if (hasData) {
      return true;
    }
  }

  return false;
};
